"use client";

import { useContext } from "react";
import { SupportChatContext, SupportChatContextValue } from "../_components/SupportChatProvider";

/**
 * The support chat context when there is one, `null` when there is not.
 *
 * `useSupportChat` throws outside the provider, which is right for the widget
 * and the sidebar button: those only exist inside the enterprise shell, and a
 * missing provider there is a wiring bug worth failing loudly on.
 *
 * The command palette is the exception. It mounts on `/create` too (ENG-835),
 * which is a top-level route with no shell, and mounting the provider there
 * would open a live-chat websocket on the acquisition funnel just so one row
 * has something to call. This lets the palette ask instead, and gate the row.
 *
 * @returns The chat context, or null outside `<SupportChatProvider>`.
 */
export const useOptionalSupportChat = (): SupportChatContextValue | null => {
  return useContext(SupportChatContext);
};
